import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export function useAccountProfileQuery(params: { impersonationContext?: Api.IImpersonationContext }) {
	const userSession = useUserSession();
	return useQuery<Api.AccountProfile | null>({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.AccountProfile>({
				path: Api.ImpersonationBroker.composeApiUrl({
					urlPath: `accountProfile`,
					impersonationContext: params.impersonationContext,
				}),
				method: 'GET',
				throwOn404: false,
			}),
		queryKey: [`accountProfile`, params.impersonationContext],
	});
}

export function invalidateAccountProfileQueries(params: { impersonationContext?: Api.IImpersonationContext }) {
	return reactQueryClient.invalidateQueries({
		queryKey: [`accountProfile`, params.impersonationContext],
	});
}
